import { Link } from "react-router-dom";
import type { LinkProps } from "react-router-dom";
import type { ReactNode } from "react";
import { buttonClass, type ButtonClassOptions } from "@/shared/components/Button";

type ButtonLinkProps = LinkProps & {
  children: ReactNode;
  className?: string;
};

export function ButtonLink({
  children,
  className,
  ...props
}: ButtonLinkProps & ButtonClassOptions) {
  return (
    <Link
      {...props}
      className={buttonClass({
        variant: props.variant,
        size: props.size,
        shape: props.shape,
        fullWidth: props.fullWidth,
        className,
      })}
    >
      {children}
    </Link>
  );
}
